import axios from "axios";
import { toast } from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const FETCH_ADMINS_PARK_REQUEST = "FETCH_ADMINS_PARK_REQUEST";
export const FETCH_ADMINS_PARK_SUCCESS = "FETCH_ADMINS_PARK_SUCCESS";
export const FETCH_ADMINS_PARK_FAILURE = "FETCH_ADMINS_PARK_FAILURE";

export const DELETE_ADMIN_PARK_REQUEST = "DELETE_ADMIN_PARK_REQUEST";
export const DELETE_ADMIN_PARK_SUCCESS = "DELETE_ADMIN_PARK_SUCCESS";
export const DELETE_ADMIN_PARK_FAILURE = "DELETE_ADMIN_PARK_FAILURE";

const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return { authorization: token };
};

export const fetchAdmins = () => async (dispatch) => {
  dispatch({ type: FETCH_ADMINS_PARK_REQUEST });

  try {
    const response = await axios.get(`${BASE_URL}/v1/api/parkAdmin`, {
      headers: getAuthHeader(),
    });

    dispatch({
      type: FETCH_ADMINS_PARK_SUCCESS,
      payload: response.data.data,   // ✅ FIXED
    });
  } catch (error) {
    dispatch({
      type: FETCH_ADMINS_PARK_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const deleteAdmin = (adminId, onSuccess) => async (dispatch) => {
  dispatch({ type: DELETE_ADMIN_PARK_REQUEST });

  try {
    await axios.delete(`${BASE_URL}/v1/api/parkAdmin/${adminId}`, {
      headers: getAuthHeader(),
    });

    dispatch({
      type: DELETE_ADMIN_PARK_SUCCESS,
      payload: adminId,
    });

    toast.success("Admin deleted successfully!");

    if (onSuccess) onSuccess();

    dispatch(fetchAdmins());
  } catch (error) {
    toast.error("Failed to delete admin");
    dispatch({
      type: DELETE_ADMIN_PARK_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};
